import { authFetch } from "~/services/fetch";

export async function makeRequestToGetOutOfServiceProductivity({
  deviceId,
  startDate,
  finishDate,
  agencyIds,
  operationUnitId,
  groupSetId,
  dispatchGroupsId,
  outOfServiceReasonId,
  exportCSV = false,
}) {
  try {
    const response = await authFetch({
      url: `/report/out-of-service-productivity`,
      method: 'POST',
      data: {
        device_id: deviceId,
        start_date: startDate,
        finish_date: finishDate,
        agency_ids: agencyIds,
        operation_unit_id: operationUnitId,
        group_set_id: groupSetId,
        dispatch_group_ids: dispatchGroupsId,
        out_of_service_reason_id:outOfServiceReasonId,
        export_csv: exportCSV,
      }
    });

    return response.data
  } catch (error) {
    console.error('ERROR GENERATE REPORT', error)
    throw error
  }
}